const MenuBadge = ({count, showCount = false}) => {
    if (!count) return null;

    if (showCount) {
        return <span className="mdb-menu-badge-count">{count}</span>;
    }

    return <span className="mdb-menu-badge-dot" aria-hidden="true" />;
};

export default MenuBadge;
